/**
 * Helpers for the live menu search box — history persistence + match scoring.
 */
import { getJSON, setJSON, removeItem } from "../../lib/safeStorage";

export const HISTORY_KEY = "zen_menu_search_history_v1";
export const HISTORY_MAX = 8;

export function loadHistory() {
    const arr = getJSON(HISTORY_KEY, []);
    return Array.isArray(arr) ? arr.slice(0, HISTORY_MAX) : [];
}

export function saveHistoryEntry(q) {
    const v = (q || "").trim();
    if (!v) return;
    const cur = loadHistory().filter((x) => x.toLowerCase() !== v.toLowerCase());
    const next = [v, ...cur].slice(0, HISTORY_MAX);
    setJSON(HISTORY_KEY, next);
}

export function clearHistory() {
    removeItem(HISTORY_KEY);
}

/**
 * Lightweight matcher — case-insensitive substring against text. Returns:
 *   1000 — exact prefix at position 0
 *    500 — word-start match (preceded by space)
 *    1..99 — interior match, lower score the deeper the position
 *      0 — no match
 */
export function scoreMatch(text, q) {
    if (!text) return 0;
    const t = text.toLowerCase();
    const i = t.indexOf(q);
    if (i < 0) return 0;
    return i === 0 ? 1000 : t[i - 1] === " " ? 500 : 100 - Math.min(i, 99);
}
